import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import {ATTENDANCE_ABSENT, ATTENDANCE_REQUESTS} from "../../Config/ApiUrl";
import {filterLastPendingData} from "../View/Attendance/Helper/Helper";
import {
    DepartmentFilterMixin, UserFilterMixin,
    WorkingShiftFilterMixin
} from "./FilterMixin";
import AttendanceHelperMixin from "./AttendanceHelperMixin";
import {convertSecondToHourMinutes} from "../../../common/Helper/Support/DateTimeHelper";
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {onlyMailEvent} from "../../../common/Components/Settings/Common/http/NotificationTemplate/Helper";

export default {
    mixins: [
        AttendanceHelperMixin,
        DatatableHelperMixin,
    ],
    data() {
        return {
            options: {
                name: this.$t('attendance_absent'),
                url: ATTENDANCE_ABSENT,
                showHeader: true,
                showCount: true,
                showClearFilter: true,
                columns: [
                    {
                        title: this.$t('name'),
                        type: 'text',
                        key: 'full_name',
                    },
                    {
                        title: this.$t('date'),
                        type: 'text',
                        key: 'date',
                    },
                ],
                filters: [],
                paginationType: "pagination",
                responsive: true,
                rowLimit: 10,
                orderBy: 'desc',
                actionType: "dropdown",
                actions: [],
            },
            isContextMenuOpen: false,
            selectedRequests: [],
            filterValue: {},
        }
    },
    methods: {
        getSelectedRows(data, allSelected) {
            if (this.filterValue.rejected) {
                this.isContextMenuOpen = false;
                return;
            }
            this.allSelected = allSelected;
            this.selectedRequests = data;
            this.isContextMenuOpen = data.length;
        },
        afterBulkAction() {
            this.isContextMenuOpen = false;
            this.$hub.$emit('reload-attendance-request-table')
        },
        getFilterValues(value) {
            this.filterValue = value;
        },
    },
}
